import type { ShipDef } from '../../sim/defs';

/** V00 — VULCAN. La coque de série, celle qu'on pilote sans avoir rien acheté.
 *
 *  ── Pourquoi son profil est VIDE ──────────────────────────────────────────
 *  Ce n'est pas un fichier en attente de contenu : c'est la définition même de
 *  la référence. `BASE_STATS` DÉCRIT le VULCAN — 480 u/s, 3 vies, 2 bombes,
 *  45 u de frôlement. Recopier ces valeurs ici sous forme de modificateurs
 *  donnerait deux sources pour un seul chiffre, et la dérive habituelle : le
 *  jour où l'une des deux bouge, on ne sait plus laquelle fait autorité.
 *
 *  Le banc d'équilibrage (`tests/balance/curve.test.ts`) mesure la courbe de
 *  puissance sur cette coque. Lui donner ne serait-ce qu'un modificateur
 *  déplacerait la référence de tout l'équilibrage du jeu — d'où l'assertion de
 *  `validateShips` qui refuse le moindre chiffre ici.
 *
 *  ── Pourquoi elle doit rester défendable en fin d'arbre ───────────────────
 *  Le plan (§6.9) exige qu'un joueur excellent franchisse le jeu à méta zéro.
 *  Cela ne tient que si le VULCAN reste un choix, et pas le rappel de ce qu'on
 *  n'a pas encore acheté. AEGIS et FANAL renoncent chacun à quelque chose qu'il
 *  est le seul à conserver : la vitesse ET les bombes. */
const vulcan: ShipDef = {
  id: 'vulcan',
  name: 'VULCAN',
  modifiers: [],
  secondaryCooldownMul: 1,
  grazeBombCharge: 0,
  text: 'Coque de série. 480 u/s, 3 vies, 2 bombes — aucun renoncement.',
};

export default vulcan;
